import * as actionTypes from "../actionTypes";
import {updateObject} from "../../shared/utils/updateObject";
import * as storageConstants from "../../shared/utils/constants/storage";
import {initialDetailsState, initialFilterState, initialOrdiniSuggestionState, initialTableDataState} from "./helper";

const initialState = {
    inCorso: initialTableDataState,
    consegnati: initialTableDataState,
    annullati: initialTableDataState,
    filter: initialFilterState,
    details: initialDetailsState,
    selectedRow: {},
    selectedTab: !sessionStorage.getItem(storageConstants.ORDERS_TAB) ? 0 : parseInt(sessionStorage.getItem(storageConstants.ORDERS_TAB)),
    ordiniSuggestion: initialOrdiniSuggestionState
}
const fetchOrdiniDataSuccess = (state, action) => {
    const tmpObject = {
        ...state[`${action.tab}`], data: action.data,
        count: action.count,
        rowsPerPage: action.rowsPerPage,
        page: action.page

    }
    return updateObject(state, {[`${action.tab}`]: tmpObject})
}

const setLoadingOrdini = (state, action) => {
    let tmpObj = { ...state[`${action.tab}`], loading: action.value };
    if (action.value) {
        tmpObj = { ...tmpObj, count: 0 };
    }
    return updateObject(state, { [`${action.tab}`]: tmpObj });
};

const changeFilterOrdini = (state, action) => {
    const tmpFilter = {...state.filter, [`${action.filterType}`]: action.value}
    return updateObject(state, {filter: tmpFilter});
}

const setSortingOrdini = (state, action) => {
    const tmpSort = {...state[`${action.tab}`], sorting: action.value}
    return updateObject(state, {[`${action.tab}`]: tmpSort})
}

const setSelectedRow = (state, action) => {
    return updateObject(state, {selectedRow: action.selectedRow});
}

const setSelectedTab = (state, action) => {
    return updateObject(state, {selectedTab: action.selectedTab});
}

const setOrdiniSuggestionLoading = (state, action) => {
    return updateObject(state, {ordiniSuggestion: {...state.ordiniSuggestion, loading: action.value}})
}

const setOrdiniFilterSuggestionData = (state, action) => {
    return updateObject(state, {ordiniSuggestion: {...state.ordiniSuggestion, menuItems: action.suggestionList}});
}


const ordiniDiSpedizioneReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_ORDINI_DATA_SUCCESS :
            return fetchOrdiniDataSuccess(state, action);
        case actionTypes.CHANGE_FILTER_ORDINI:
            return changeFilterOrdini(state, action);
        case actionTypes.SET_SELECTED_TABLE_ROW:
            return setSelectedRow(state, action);
        case actionTypes.SET_SELECTED_TAB:
            return setSelectedTab(state, action);
        case actionTypes.SET_SORTING_ORDINI:
            return setSortingOrdini(state, action);
        case actionTypes.SET_LOADING_ORDINI:
            return setLoadingOrdini(state, action);
        case actionTypes.SET_ORDINI_SUGGESTION_LOADING:
            return setOrdiniSuggestionLoading(state, action);
        case actionTypes.SET_ORDINI_FILTER_SUGGESTION_DATA:
            return setOrdiniFilterSuggestionData(state, action);
        default:
            return state;
    }
}

export default ordiniDiSpedizioneReducer;
